module.exports = __webpack_public_path__ + "static/widernet-web-2-7fa66d3dfb20f5af1b60002e25de7609.jpg";